export default "__VITE_ASSET__5bbdad71__"